import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    useTheme,
} from '@mui/material';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import '../map/leafletConfig';
import { MapClickHandler } from '../map';
import Button from '../button';

const MapDialog = ({ open, onClose, initialPosition, onSave }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const [mapPosition, setMapPosition] = useState(initialPosition || [37.5665, 126.9780]);

    // initialPosition이 변경되면 mapPosition 업데이트
    useEffect(() => {
        if (initialPosition && Array.isArray(initialPosition) && initialPosition.length === 2) {
            setMapPosition(initialPosition);
        }
    }, [initialPosition]);

    // 지도 위치 변경 핸들러
    const handleMapPositionChange = (position) => {
        setMapPosition(position);
    };

    // 저장 핸들러
    const handleSave = () => {
        if (onSave) {
            onSave(mapPosition);
        }
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            slotProps={{
                root: { keepMounted: false },
            }}
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: '12px',
                    backgroundColor: theme.palette.background.default,
                    border: `1px solid ${theme.palette.figma.white[20]}`
                }
            }}
        >
            <DialogTitle sx={{
                p: 3,
                borderBottom: `1px solid ${theme.palette.figma.white[20]}`,
                backgroundColor: theme.palette.figma.white[5]
            }}>
                <Typography sx={{
                    fontWeight: 600,
                    fontSize: '18px',
                    color: theme.palette.text?.primary || 'rgba(255, 255, 255, 0.9)',
                    textAlign: 'center'
                }}>
                    {t('select_location')}
                </Typography>
            </DialogTitle>

            <DialogContent sx={{ p: 0 }}>
                <Box sx={{ height: '500px', width: '100%' }}>
                    <MapContainer
                        center={mapPosition}
                        zoom={15}
                        style={{ height: '100%', width: '100%' }}
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        />
                        <Marker position={mapPosition} />
                        <MapClickHandler onPositionChange={handleMapPositionChange} />
                    </MapContainer>
                </Box>
            </DialogContent>

            <DialogActions sx={{
                p: 3,
                gap: 2,
                justifyContent: 'center',
                borderTop: `1px solid ${theme.palette.figma.white[20]}`
            }}>
                <Button
                    variant="gray"
                    onClick={onClose}
                    sx={{ minWidth: '120px' }}
                >
                    {t('cancel')}
                </Button>
                <Button
                    onClick={handleSave}
                    sx={{ minWidth: '120px' }}
                >
                    {t('save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MapDialog;

